import React from 'react';
import { useSelector } from 'react-redux';

import _ from 'lodash';
import cx from 'classnames';
import { Tab } from 'react-bootstrap';
import { PaletteContext } from '.';

import {
  CONTAINER,
} from 'constants/widgetTypes';

import styles from './palette.module.scss';
import { WidgetPaletteFolders } from './multiWidgetFolderPalette';

export const ContainerPalette = ({ editorSession, defaultParent }) => {
  const paletteContext = React.useContext(PaletteContext);

  const { palettes = [] } = paletteContext;
  const paletteData = palettes.find(item => item.type === 'CONTAINERS');
  const defaultId = _.get(paletteData, 'defaultId', null);
  const brandkitId = _.get(paletteData, 'brandkitId', null);

  return (
    <Tab.Pane eventKey="CONTAINERS" className={cx(styles.tabPane, styles.commonPalette)}>
      <WidgetPaletteFolders
        editorSession={editorSession}
        defaultParent={defaultParent}
        paletteId={brandkitId}
        type={'default'}
        paletteData={paletteData}
        typeName={'CONTAINERS'}
        defaultPaletteId={defaultId}
      />
    </Tab.Pane>
  );
}

const generatecontainerData = () => {

  return {
    name: "Container",
    type: CONTAINER,
    properties: {
      "desktop": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "50%, 0px",
            "rotate": "0deg"
          },
          "width": "1200px",
          "height": "500px"
        },
        "padding": 0,
        "background": {
          "type": "color",
          "color": {
            "type": "solid",
            "r": 242,
            "g": 242,
            "b": 242,
            "a": 1
          },
          "media": null,
          "opacity": 0,
          "scale": null,
          "position": null
        },
        "shadow": {
          "color": {
            "type": "solid",
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 1
          },
          "axes": {
            "x": "0",
            "y": "0",
            "b": "0"
          },
          "show": false
        },
        "border": {
          "sides": null,
          "color": {
            "type": "solid",
            "r": 255,
            "g": 255,
            "b": 255,
            "a": 1
          },
          "width": "0",
          "radius": {
            "lock": false,
            "topLeft": "0",
            "topRight": "0",
            "bottomLeft": "0",
            "bottomRight": "0"
          }
        },
      },
      "mobile": {
        "visible": true,
        "layout": {
          "transform": {
            "translate": "0px, 0px",
            "rotate": "0deg"
          },
          "width": "100%",
          "height": "200px"
        },
        "padding": 0,
        "container": {
          "minWidth": 375,
          "alignment": "center"
        },
        "background": null,
        "shadow": null,
        "border": null,
      }
    },
  }
}

export const containers = [
  {
    id: 'container',
    name: 'container',
    render: () => {
      return <img className={cx(styles.menu, styles.basic)} src="/images/palette/container/basiccontainer.png" />
    },
    data: generatecontainerData()
  }
]